// extracted by mini-css-extract-plugin
export default {"input":"styles_input__e56l5","circle_wrap":"styles_circle_wrap__lok87","circle":"styles_circle__gTuDl","light":"styles_light__pzZbi"};